import { RouterProvider } from "react-router-dom";
import { router } from "../routes/router";

export const AppProd = () => {
  return <RouterProvider router={router} />;
};
